import script from "./UserOEM.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserOEM.vue?vue&type=script&setup=true&lang=ts"

import "./UserOEM.vue?vue&type=style&index=0&id=38c07fdf&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c07fdf"]])

export default __exports__